// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deleteButtonDraftPopUpMainWrapper[data-v-9f9dc676],.mergeButtonDraftPopUpMainWrapper[data-v-9f9dc676]{position:relative;width:100%;display:flex;flex-direction:column}.textContent[data-v-9f9dc676]{color:var(--color-black);font-size:var(--font-size-big)}.hollowText[data-v-9f9dc676]{color:var(--color-main);font-weight:500}.hollowText[data-v-9f9dc676],.mainText[data-v-9f9dc676]{font-size:var(--font-size-small)}.mainText[data-v-9f9dc676]{color:var(--color-white);font-weight:600}", ""]);
// Exports
module.exports = exports;
